import { render } from "./WayOfPayment.vue?vue&type=template&id=76f02d7a&scoped=true"
import script from "./WayOfPayment.vue?vue&type=script&lang=js"
export * from "./WayOfPayment.vue?vue&type=script&lang=js"

import "./WayOfPayment.vue?vue&type=style&index=0&id=76f02d7a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/multiCotizadorCR/multiCotizadorCR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76f02d7a"]])

export default __exports__